var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.prior)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Приоритет'),expression:"'Приоритет'"}],staticClass:"prior label_",style:(_vm.style)},[_vm._v(_vm._s(_vm.prior))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }